import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOpeninline = (props) => /* @__PURE__ */ _jsx("svg", {
	enableBackground: "new 0 0 16 16",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m.1 7.5c2-3.6 4.7-5.5 7.9-5.5s5.9 1.9 7.9 5.5c.2.3.2.7 0 1-2.3 3.6-4.9 5.5-7.9 5.5s-5.6-1.9-7.9-5.5c-.1-.3-.2-.7 0-1zm5-1.4c.3.5.8.9 1.4.9.8 0 1.5-.7 1.5-1.5 0-.6-.4-1.1-.9-1.4.3-.1.6-.1.9-.1 1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-.3 0-.6.1-.9zm.1-1.4c-1.1.7-2.1 1.8-3 3.3 1.8 2.7 3.7 4 5.8 4s4-1.3 5.8-4c-1.6-2.7-3.5-4-5.8-4-.3 0-.7 0-1 .1-.2-.1-.3-.1-.5-.1-.6 0-1 .3-1.3.7z" })
});
export default SvgEyeOpeninline;
